export const EDAP_PAGE_MODULE_VIEW = 'page.module.view';
export const EDAP_CONTENT_MODULE_PRESENTED = 'content_module.presented';
export const EDAP_CONTENT_INTERACTION_SELECTED = 'interaction.selected';
export const EDAP_GENERIC_EVENT = 'generic.event';
export const EDAP_INTERACTION_CLICK = 'interaction-click';
export const EDAP_LINK_CLICK = 'link-click';
export const EDAP_TAB_CLICK = 'tab-click';
export const EDAP_EXPAND = 'expand';
export const EDAP_COLLAPSE = 'collapse';
export const EDAP_COLLAPSIBLE_LINKPILE_ACTION_LOCATION = 'collapsible-linkpile-component';
export const EDAP_TABBED_LINKPILE_ACTION_LOCATION = 'tabbed-linkpile-component';
export const EDAP_EVENT_POSITION_FIRED_TOP = 'top';
export const EDAP_EVENT_POSITION_FIRED_BOTTOM = 'bottom';

export const HAPI_PLUGIN_GLOBAL_CONFIG_RESOLUTION = '@homeaway/hapi-global-config-resolution';
export const HAPI_PLUGIN_GLOBALIZATION_RESOLUTION = '@homeaway/hapi-globalization-resolution';
export const HAPI_PLUGIN_DATADOG = '@homeaway/hapi-datadog';
